import React, { ButtonHTMLAttributes } from "react";
import { BasicButton, IconButton, RoundedButton } from "./styled";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: React.ReactNode | string;
  icon?: React.ReactNode;
  iconname?: string;
  iconRight?: React.ReactNode;
	iconLeft?: React.ReactNode;
  short?: boolean;
  secondary?: boolean;
  basic?: boolean;
  onClick?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
  iconBtn?: boolean;
  danger?: boolean;
	rounded?: boolean;
	primary?:boolean;
	width?:string | null;
};

const defaultProps: ButtonProps = {
  label: "",
  short: false,
  type: undefined,
  icon: null,
  iconname: "",
  iconRight: null,
  iconLeft: null,
  secondary: false,
  basic: false,
	rounded: false,
  iconBtn: false,
  onClick: () => {},
  danger: false,
	primary: false,
  width: null

};

function Button({
  icon,
  iconname,
  iconRight,
	iconLeft,
  label,
  short,
  disabled,
  className,
  type,
  basic,
  iconBtn,
	rounded,
	primary,
  width,
  onClick,
  ...props
}: ButtonProps) {
	const hasNotIcon = !iconLeft && !iconRight;
  const typeBtn = type || 'button'
  const basicButton = (
    <BasicButton onClick={onClick} width={width} type={typeBtn}>{label}</BasicButton>
  );

  
  const iconButton = (
    <>
      <IconButton danger onClick={onClick} type={typeBtn}>
        <img src={icon as string} alt={''} />
      </IconButton>
    </>
  );

	const roundedButton = (
			<RoundedButton primary={primary} centerContent={hasNotIcon} width={width} type={typeBtn}>
				{iconLeft && <img src={iconRight as string} alt={''} />}
				{label}
				{iconRight && <img src={iconRight as string} alt={''} />}
			</RoundedButton>
	)
  return (
    <>
      {basic && basicButton}
      {iconBtn && iconButton}
			{rounded && roundedButton}
    </>
  );
}

Button.defaultProps = defaultProps;

export { Button };
